
/**
 * https://developerx.atlassian.net/browse/CS-5342
 * https://developerx.atlassian.net/browse/CS-5362
 *
 * Created at : 14 January 2022           Updated at : 21 January 2022
 * Created by : Risman Abdilah            Updated by : Risman Abdilah
 *
 * Version 1.0.0
 */
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component({})
export default class CoachMark extends Vue {
  // PROPS
  @Prop({ default: 0 })
  private activeIndex: number;
  @Prop({ default: [] })
  private steps: Array<any>;
  @Prop({ default: false })
  private isPaging: boolean;
  @Prop({ default: [] })
  private isHeader: boolean;
  @Prop({ default: "" })
  private target: string;
  @Prop({ default: "" })
  private placement: string;
  @Prop({ default: "" })
  private container: string;
  @Prop({ default: false })
  private isShow: boolean;
  @Prop({ default: "" })
  private title: string;
  @Prop({ default: "" })
  private content: string;
  @Prop({ default: false })
  private close: boolean;
}
